import { useRef } from 'react';

import { initializeIcons } from './initializeIcons';
import { registerCustomIcons } from './registerCustomIcons';

type UsePrepareIcons = () => void;
export const usePrepareIcons: UsePrepareIcons = () => {
  const hasPreparedRef = useRef(false);

  if (hasPreparedRef.current) {
    return;
  }
  hasPreparedRef.current = true;

  registerCustomIcons();
  initializeIcons();
};
